import AuthFormForm from './auth-form-form';
import AuthFormIcon from './auth-form-icon';
import AuthFormParagraph from './auth-form-paragraph';
import AuthFormRoot from './auth-form-root';
import AuthFormSubTitle from './auth-form-sub-title';
import AuthFormTitle from './auth-form-title';

export const AuthForm = {
	Root: AuthFormRoot,
	Title: AuthFormTitle,
	SubTitle: AuthFormSubTitle,
	Form: AuthFormForm,
	Paragraph: AuthFormParagraph,
	Icon: AuthFormIcon,
};
